import { withInstall } from '../../utils';
import DescriptionItem from './src/description-item.vue';
import Descriptions from './src/descriptions.vue';

export const IDescriptions = withInstall(Descriptions); // 增加类型
export const IDescriptionItem = withInstall(DescriptionItem);

export default {
  IDescriptions,
  IDescriptionItem,
};
